<template>
    <div ref="bubble" class="container"></div>
</template>

<script>
import echarts from 'echarts';
import {chartMerge} from 'echarts-config';
import {bubbleData} from '@/runtime-components/data';

export default {
    name: 'de-bubble',
    props: {
        data: {
            type: [Object, Array],
            default: () => {
                return bubbleData;
            }
        },
        legend: {
            type: String,
            default: '北京,上海,广州'
        }
    },
    data() {
        let chartIns = {
            chart: null,
            option: []
        };
        return {
            getChart() {
                return chartIns;
            }
        }
    },
    watch: {
        legend(v) {
            let chart = this.getChart().chart;
            let legend = v.split(',');
            let series = this.dealData(this.data);
            chart && (chart.setOption({
                series: series,
                legend: {
                    data: legend
                },
            }));
        },
        data: {
            handler(v) {
                let chart = this.getChart().chart;
                let series = this.dealData(v);
                chart && (chart.setOption({
                    series: series
                }));
            },
            deep: true
        }
    },
    mounted() {
        this.initChart();
    },
    destroyed(){
        this.destroyChart();
    },
    methods: {
        initChart(type) {
            let chartIns = this.getChart();
            //初始化设置主题 dark light
            window._CHART_THEMETYPE_ = type || 'dark';
            let legend = this.legend.split(',');
            let series = this.dealData(this.data);
            //echarts
            const chart = chartMerge(
                {
                    chartType: 'Bubble'
                }, {
                    legend: {
                        textStyle: {
                            color: '#fff'
                        },
                        data: legend
                    },
                    series: series,
                    visualMap: [{
                        type : 'piecewise'
                    }]
                });
            if (!chartIns.chart) {
                chartIns.chart = echarts.init(this.$refs.bubble);
                chartIns.chart.setOption(chart);
                this.resizeChart = chartIns.chart.resize;
            }
        },
        dealData(data) {
            if (data) {
                let tempData = data.concat([]);
                let arr = [];
                let legend = this.legend.split(',');
                tempData.forEach((item, index)=>{
                    arr.push({
                        name: legend[index],
                        data: item
                    });
                });
                return arr;
            }
        },
        destroyChart() {
            const chartIns = this.getChart();
            if(chartIns.chart){
               chartIns.chart.dispose();
               chartIns.chart = null;
            }
        }
    }
}
</script>

<style scoped>
@import url('~@/runtime-components/assets/common.css');
</style>